import { useEffect, useState } from "react"
import { Row, Col, Nav } from "react-bootstrap"
import {ArrowRightCircle} from 'react-bootstrap-icons'
import headerImg from '../assets/img/header-img.svg'
import TrackVisibility from "react-on-screen";


export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const toRotate = ['eat(); 🍽();', 'sleep(); 🛌();', 'code(); 💻();', 'repeat(); 🔁();'];
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() *100)
  const [index, setIndex] = useState(1);
  const period = 500;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => { 
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className='banner' id='home'>
      <Row className='align-items-center'>
        <Col xs={12} md={6} xl={7}>
        <div className='banner-content'>
          <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1>{`Hi! I'm Nuttanee Knight`} <br></br> <span className="txt-rotate" dataPeriod="1000"><span className="wrap">{text}</span></span></h1>
                <p>Full Stack Developer<br></br> with customer service background. Cannot wait to collaborate with you!</p>
                  <Nav.Link href="#contact"><button onClick={() => console.log('contact')}>Let’s Connect <ArrowRightCircle href='#contact' size={25} /></button></Nav.Link>
              </div>}
            </TrackVisibility>
            </div>
        </Col>
        <Col xs={4} md={1} xl={1}>
          <img src={headerImg} alt='Header Img'></img>
        </Col>
      </Row>
    </section>
  )
}
